/* BET-A 2026-10-17: wrapped in a guard so the quick-add modal can re-run this file without
   "Identifier 'ProductDescriptionTabsTest' has already been declared". Behaviour unchanged. */
if (!customElements.get('product-description-tabs-test')) {
class ProductDescriptionTabsTest extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-product-description-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-product-description-panel]'));
    this.accordions = Array.from(this.querySelectorAll('[data-product-description-accordion]'));
    this.mobileMedia = window.matchMedia('(max-width: 749px)');
    this.activeIndex = -1;

    if (this.hasAttribute('data-legacy-fold')) {
      if (!this.panels.length || !this.accordions.length) return;
      this.accordions.forEach((accordion, index) => {
        accordion.addEventListener('click', () => {
          const nextIndex = this.activeIndex === index ? -1 : index;
          this.activeIndex = nextIndex;
          this.panels.forEach((panel, panelIndex) => {
            const isActive = panelIndex === nextIndex;
            panel.classList.toggle('is-active', isActive);
            const body = panel.querySelector('[data-product-description-panel-body]');
            if (body) body.hidden = !isActive;
          });
          this.accordions.forEach((item, itemIndex) => {
            item.setAttribute('aria-expanded', itemIndex === nextIndex ? 'true' : 'false');
          });
        });
      });
      this.classList.add('is-ready');
      return;
    }

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
    });

    this.accordions.forEach((accordion, index) => {
      accordion.addEventListener('click', () => {
        const nextIndex = this.mobileMedia.matches && this.activeIndex === index ? -1 : index;
        this.select(nextIndex);
      });
    });

    this.select(0); // LH 2026-10-24: first tab open on load (mobile is tabs-only now)
    this.classList.add('is-ready');
  }

  select(activeIndex) {
    const isMobile = this.mobileMedia.matches;
    this.activeIndex = activeIndex;

    this.tabs.forEach((tab, index) => {
      const isActive = index === activeIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel, index) => {
      const isActive = index === activeIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isMobile && !isActive;
    });

    this.accordions.forEach((accordion, index) => {
      accordion.setAttribute('aria-expanded', index === activeIndex ? 'true' : 'false');
    });
  }

  onTabKeydown(event, index) {
    let nextIndex = index;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = index + 1 >= this.tabs.length ? 0 : index + 1;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = index - 1 < 0 ? this.tabs.length - 1 : index - 1;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.select(nextIndex);
    this.tabs[nextIndex].focus();
  }
}

  customElements.define('product-description-tabs-test', ProductDescriptionTabsTest);
}
